export default __webpack_public_path__ + "static/media/notice.3d02369c.svg";